type InitialUserTypePromptParams = {
  hasUserProfile: boolean;
  userType?: string | null;
};

export function shouldPromptForInitialUserType({
  hasUserProfile,
  userType,
}: InitialUserTypePromptParams) {
  if (!hasUserProfile || userType) {
    return false;
  }

  return true;
}
